import { useEffect, useState } from 'react';

/**
 * Milliseconds left until `expiresAt`, re-rendering once a second. A demo wall
 * lives five minutes, so the number on screen has to be the real one - a clock
 * that only updates on reconnect would quietly lie for most of the wall's life.
 */
export function useCountdown(expiresAt: number | null | undefined): number | null {
  const [remaining, setRemaining] = useState(() =>
    expiresAt == null ? null : Math.max(0, expiresAt - Date.now()),
  );

  useEffect(() => {
    if (expiresAt == null) {
      setRemaining(null);
      return;
    }
    const tick = () => setRemaining(Math.max(0, expiresAt - Date.now()));
    tick();
    const timer = setInterval(tick, 1000);
    return () => clearInterval(timer);
  }, [expiresAt]);

  return remaining;
}

/** `4:07`, counting down. Seconds matter at this scale, so no rounding to minutes. */
export function formatCountdown(ms: number): string {
  const total = Math.max(0, Math.round(ms / 1000));
  return `${Math.floor(total / 60)}:${String(total % 60).padStart(2, '0')}`;
}
